import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@descope/react-sdk';
import AppShell from './components/layout/AppShell';
import AuthGuard from './components/auth/AuthGuard';
import RequestsExplorer from './pages/RequestsExplorer';
import MetricsDashboard from './pages/MetricsDashboard';
import OnboardingDashboard from './pages/OnboardingDashboard';
import SecurityAssessment from './pages/SecurityAssessment';
import ChatWithUsage from './pages/ChatWithUsage';
import FeatureRequests from './pages/FeatureRequests';
import AgentsOverview from './pages/AgentsOverview';
import Apps from './pages/Apps';
import ConversationDrawer from './components/agents/ConversationDrawer';

// In production we should never silently disable auth.
// Default to the InternalApps Descope project used by the backend.
const DESCOPE_PROJECT_ID =
  import.meta.env.VITE_DESCOPE_PROJECT_ID || 'P373WjVPQVbXkwLMeUGBB48Uw8bD';

function App() {
  // Allow skipping auth only in Vite dev mode (local dev convenience).
  // In production builds, auth is always enabled.
  const skipAuth = import.meta.env.DEV && !import.meta.env.VITE_DESCOPE_PROJECT_ID;
  if (skipAuth) {
    return (
      <AppShell>
        <Routes>
          <Route path="/" element={<Navigate to="/requests" replace />} />
          <Route path="/requests" element={<RequestsExplorer />}>
            <Route path="thread/:threadId" element={<ConversationDrawer />} />
          </Route>
          <Route path="/metrics" element={<MetricsDashboard />} />
          <Route path="/onboarding" element={<OnboardingDashboard />} />
          <Route path="/security" element={<SecurityAssessment />} />
          <Route path="/agents" element={<AgentsOverview />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/chat" element={<ChatWithUsage />} />
          <Route path="/features" element={<FeatureRequests />} />
          <Route path="*" element={<Navigate to="/requests" replace />} />
        </Routes>
      </AppShell>
    );
  }

  return (
    <AuthProvider projectId={DESCOPE_PROJECT_ID}>
      <AuthGuard>
        <AppShell>
          <Routes>
            <Route path="/" element={<Navigate to="/requests" replace />} />
            <Route path="/requests" element={<RequestsExplorer />}>
              <Route path="thread/:threadId" element={<ConversationDrawer />} />
            </Route>
            <Route path="/metrics" element={<MetricsDashboard />} />
            <Route path="/onboarding" element={<OnboardingDashboard />} />
            <Route path="/security" element={<SecurityAssessment />} />
            <Route path="/agents" element={<AgentsOverview />} />
            <Route path="/chat" element={<ChatWithUsage />} />
            <Route path="/features" element={<FeatureRequests />} />
            <Route path="*" element={<Navigate to="/requests" replace />} />
          </Routes>
        </AppShell>
      </AuthGuard>
    </AuthProvider>
  );
}

export default App;
